import React from 'react';
import './PrivacyPage.css';

const PrivacyPage = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Introduction</h2>
            <p>
              At SnapTools, we take your privacy seriously. This Privacy Policy outlines how we handle your information
              when you use our browser-based image editing tools.
            </p>
            <p>
              Please read this policy carefully to understand our practices regarding your data.
            </p>
          </section>
          
          <section className="privacy-section">
            <h2>Data Collection</h2>
            <p>
              <strong>Images and Files:</strong> All image processing is done locally in your browser. We do not upload, store, 
              or transmit your images to any server. Your images never leave your device when using our tools.
            </p>
            <p>
              <strong>Usage Information:</strong> We may collect anonymous usage statistics to help improve our services,
              such as which tools are most popular and general user behavior on our site.
            </p>
          </section>
          
          <section className="privacy-section">
            <h2>Cookies</h2>
            <p>
              We use cookies to enhance your experience on our website. These cookies are used to remember your preferences
              and provide analytics that help us improve our services.
            </p>
            <p>
              You can control cookies through your browser settings. Disabling cookies may affect some functionality of the site.
            </p>
          </section>
          
          <section className="privacy-section">
            <h2>Third-Party Services</h2>
            <p>
              Our website may use third-party services for analytics and performance monitoring. These services may collect
              anonymous information about your visit to help us improve our tools.
            </p>
            <p>
              We do not share your personal information with these services.
            </p>
          </section>
          
          <section className="privacy-section">
            <h2>Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. When we do, we will revise the "last updated" date at the top
              of the policy. We encourage you to periodically review this page to stay informed about our information practices.
            </p>
          </section>
          
          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at privacy@snaptools.example.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage; 